import isPropValid from '@emotion/is-prop-valid'
import { CreateStyled } from '@emotion/styled'

const TRANSIENT_PREFIX = '$'

// emotion solution for https://styled-components.com/docs/api#transient-props
export const transientOptions: Parameters<CreateStyled>[1] = {
  shouldForwardProp: (propName: string) => isPropValid(propName) && !propName.startsWith(TRANSIENT_PREFIX),
}
